import AvatarGroup from 'tio-reimagined/components/avatar-group';
import type { AvatarGroupPerson } from 'tio-reimagined/components/avatar-group';
import Component from '@glimmer/component';
import type { Appearance } from '../../services/appearance.ts';

interface WhosViewingComponentSignature {
  Args: {
    appearances: Appearance[] | Record<string, Appearance>;
  };
  Element: HTMLDivElement;
}

export default class WhosViewingComponent extends Component<WhosViewingComponentSignature> {
  get people(): AvatarGroupPerson[] {
    const appearances = !this.args.appearances
      ? []
      : Array.isArray(this.args.appearances)
        ? this.args.appearances
        : Object.values(this.args.appearances);

    return appearances.map((a) => ({
      name: a?.name || 'Unknown User',
    }));
  }

  <template>
    <AvatarGroup @people={{this.people}} @size="sm" @spacing="normal" ...attributes />
  </template>
}
